<template>
  <section class="mt-5 sm-max:px-6">

      <h2 class="text-42 sm-max:mb-4 sm-max:px-4 md-max:pt-8 text-center pt-12 max-w-xl m-auto leading-head pb-4 sm-max:text-21 md-only:text-32">

        <div>

          <div>
         <span class="font-bold" v-html="titleBold">

         </span>

            <em class="italic font-medium" style="font-family: sans-serif;">{{ titleItalic }}</em>
            <span class="font-bold">...
          </span>
          </div>
        </div>
      </h2>

    <div>
      <nuxt-img
          class="w-full md:block hidden"
          loading="lazy"
          width="1208"
          height="1759"
          sizes="xs:320px sm:640px md:768px lg:1024px xl:1200px 2xl:1208px"
          format="webp"
          :alt="imageDesktopAlt"
          :src="imageDesktop"
      />

      <nuxt-img
          class="w-full md:hidden block"
          loading="lazy"
          width="600"
          height="3488"
          sizes="xs:320px sm:640px md:600px lg:600px xl:600px 2xl:600px"
          format="webp"
          :alt="imageMobileAlt"
          :src="imageMobile"
      />
    </div>

  </section>
</template>

<script setup>

const props = defineProps({
  titleBold: {
    type: String,
    default: 'People All Over the USA Are'
  },
  titleItalic: {
    type: String,
    default: 'Loving This Coffee',
  },
  imageDesktop: {
    type: String,
    default: 'all-people-desktop.jpg',
  },
  imageDesktopAlt: {
    type: String,
    default: 'all-people',
  },
  imageMobile: {
    type: String,
    default: 'all-people-mobile.jpg',
  },
  imageMobileAlt: {
    type: String,
    default: 'all-people',
  },
})


defineBuilderComponent({
    friendlyName: 'AllPeopleImage',
    canHaveChildren: true,
    description: 'Test description',
    ignored: false,
    inputs: [
      {
        name: 'titleBold',
        type: 'text',
        defaultValue: 'People All Over the USA Are ',
      },
      {
        name: 'titleItalic',
        type: 'text',
        defaultValue: 'Loving This Coffee',
      },
      { name: 'imageDesktop', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'], defaultValue: '/all-people-desktop.jpg' },
      {
        name: 'imageDesktopAlt',
        type: 'text',
        defaultValue: 'all-people',
      },
      { name: 'imageMobile', type: 'file', allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'], defaultValue: '/all-people-mobile.jpg' },
      {
        name: 'imageMobileAlt',
        type: 'text',
        defaultValue: 'all-people',
      },
    ],
  });
</script>